<template>
    <div v-if="isClass" v-bind:class="dropdownAccount">
        <multiselect v-model="selectedValue"
                     @input="$emit('input', selectedValue.id)"
                     :options="options"
                     :multiple="false"
                     track-by="name"
                     :clear-on-select="false"
                     :show-labels="false"
                     label="name"
                     :preselect-first="true"
                     v-bind:placeholder="$t('SaleInvoiceDropdown.Selectinvoice')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
        </multiselect>
    </div>
    <div v-else-if="isDisabled">
        <multiselect v-model="selectedValue"
                     @input="$emit('input', selectedValue.id)"
                     :options="options"
                     :multiple="false"
                     track-by="name"
                     disabled
                     :clear-on-select="false"
                     :show-labels="false"
                     label="name"
                     :preselect-first="true"
                     v-bind:placeholder="$t('Selectinvoice')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
        </multiselect>
    </div>
    <div v-else>
        <multiselect v-model="selectedValue"
                     @input="$emit('input', selectedValue.id)"
                     :options="options"
                     :multiple="false"
                     track-by="name"
                     :clear-on-select="false"
                     :show-labels="false"
                     label="name"
                     :preselect-first="true"
                     v-bind:placeholder="$t('Selectinvoice')" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left ' : 'arabicLanguage '">
        </multiselect>
    </div>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'

    import Multiselect from "vue-multiselect";
    export default {
        mixins: [clickMixin],

        name: "SaleInvoiceDropdown",
        props: ["value", 'dropdownaccount', 'isClass', 'isCredit', 'selectedIdInvoice', 'isExpense', 'contactId', 'isDisabled', 'IsService'],

        components: {
            Multiselect,
        },
        data: function () {
            return {
                dropdownAccount: "",
                options: [],
                selectedValue: [],
                isDropdown: true
            };
        },
        methods: {
            getData: function () {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                var status = 'Paid';
                if (this.isCredit) {
                    status = 'Credit';
                }
                var isRecipt = false;
                if (this.isExpense) {
                    isRecipt = true;
                }
                if (root.contactId == undefined) {
                    root.contactId = '';
                }
                var url = '';
                if (this.IsService) {
                    url = '/Sale/SaleServiceList?status=' + status +  '&isDropdown=' + root.isDropdown + '&isExpense=' + isRecipt + '&contactId=' + root.contactId
                }
                else {
                    url = '/Sale/SaleList?status=' + status + '&isDropdown=' + root.isDropdown + '&isExpense=' + isRecipt + '&contactId=' + root.contactId
                }
                
                this.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {

                    if (response.data != null) {
                        response.data.results.forEach(function (result) {
                            
                            if (root.value == result.id && root.value != undefined) {
                                root.selectedValue.push({
                                    id: result.id,
                                    name: result.registrationNumber,
                                    amount: result.netAmount
                                });
                            }

                            root.options.push({
                                id: result.id,
                                name: result.registrationNumber,
                                amount: result.netAmount
                            })
                        })

                        if (root.options.length > 0) {
                            if (root.selectedIdInvoice != undefined && root.selectedIdInvoice.length > 0 && root.values == undefined) {
                                root.selectedIdInvoice.forEach(function (x) {
                                    root.options.splice(root.options.findIndex(function (y) {
                                        return y.id === x.saleInvoice;
                                    }), 1);
                                });

                            }




                        }
                    }
                });
            },
            GetAmountOfSelected: function () {
                
                if (this.selectedValue.length > 0)
                    return this.selectedValue[0].amount;
                else
                    return this.selectedValue.amount;
            }
        },
        computed: {

        },
        mounted: function () {
            this.dropdownAccount = this.dropdownaccount;

            this.getData();
        }
    }
</script>
